import { useAppDispatch, useAppSelector } from "app/store";
import { setSelectedApproval } from "./slice";
import { ApprovalResponse } from "components/create-edit-approval-modal/definitions";

export const useApproval = () => {
  const dispatch = useAppDispatch();
  const selectedApproval = useAppSelector(
    (state) => state.approval.selectedApproval
  );
  const hasApprovalLoadingError = useAppSelector(
    (state) => state.approval.hasApprovalLoadingError
  );
  const isApprovalLoading = useAppSelector(
    (state) => state.approval.isApprovalLoading
  );
  const approvalError = useAppSelector((state) => state.approval.approvalError);

  return {
    selectedApproval: selectedApproval,
    hasApprovalLoadingError: hasApprovalLoadingError,
    isApprovalLoading: isApprovalLoading,
    approvalError: approvalError,
    setSelectedApproval: (payload: ApprovalResponse) =>
      dispatch(setSelectedApproval(payload)),
  };
};
